var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"back-to-top",on:{"click":_vm.backToTop}},[_c('icon-back-to-top')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }